import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSignAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.78 11.88-2-2.5A1.0004 1.0004 0 0 0 19 9h-6V3a1.0002 1.0002 0 0 0-1.7071-.7071A.9997.9997 0 0 0 11 3v1H5a.9999.9999 0 0 0-.78.38l-2 2.5a1 1 0 0 0 0 1.24l2 2.5A.9995.9995 0 0 0 5 11h6v9H9a1.0002 1.0002 0 0 0-.7071 1.7071 1 1 0 0 0 .707.2929H15a1.0003 1.0003 0 0 0 1-1 1.0001 1.0001 0 0 0-1-1h-2v-4h6a.9996.9996 0 0 0 .78-.38l2-2.5a1 1 0 0 0 0-1.24ZM11 9H5.48l-1.2-1.5L5.48 6H11v3Zm7.52 5H13v-3h5.52l1.2 1.5-1.2 1.5Z"/>
  </SvgIcon>
}

export default LineSignAltIcon
